import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
@Component({
  selector: 'app-user-guest-list-v2',
  templateUrl: './user-guest-list-v2.component.html',
  styleUrls: ['./user-guest-list-v2.component.scss'],
})
export class UserGuestListV2Component implements OnInit {
  @Input() userGuestList: any;
  @Input() guestType: string;
  noData: boolean;
  public currentHeaderData: any = {
    modalSlotEnd : true,
    title : 'shared.user_guest_list.select_guest',
    marl20 : true
  };

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.noData = false;
    if(this.guestType){
      this.userGuestList = this.userGuestList;
    }
  }

  closeModal() {
    this.modalController.dismiss();
  }

  selectGuest(item) {
    this.modalController.dismiss({
      ...item,
    });
  }
}
